module.exports = __webpack_public_path__ + "5-7abcb8e7.png";